import React, { useState } from "react";
import { Menu, Drawer, Button } from "antd";
import {
  MenuOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";

const Sidebar = ({ topics, activeTopic, setActiveTopic }) => {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  const menuItems = topics.map((topic) => ({
    key: topic.id,
    label: topic.name,
  }));

  const handleMenuClick = ({ key }) => {
    setActiveTopic(key);
    setDrawerVisible(false); // Close drawer after selection on mobile
  };

  return (
    <>
      {/* Mobile Header */}
      <div className="mobile-header">
        <Button
          type="text"
          icon={<MenuOutlined style={{ fontSize: "24px" }} />}
          onClick={() => setDrawerVisible(true)}
          className="hamburger-button"
        />
        <div className="mobile-title">
          <h1>AI Made Human</h1>
        </div>
      </div>

      {/* Mobile Drawer */}
      <Drawer
        placement="left"
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
        closeIcon={null}
        width={280}
        className="mobile-drawer"
        styles={{
          body: { padding: 0 },
        }}
      >
        <div className="sidebar-header">
          <h1>AI Made Human</h1>
          <p style={{ marginBottom: "8px" }}>Learn AI the easy way!</p>
          <a
            href="https://www.amazon.com/dp/B0G4W6F1PN"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              marginTop: "8px",
              fontWeight: 600,
              color: "#0071e3",
              textDecoration: "none",
            }}
          >
            📖 Buy the Book ↗
          </a>
        </div>
        <Menu
          mode="vertical"
          selectedKeys={[activeTopic]}
          items={menuItems}
          onClick={handleMenuClick}
          style={{ border: "none" }}
        />
      </Drawer>

      {/* Desktop Sidebar */}
      <aside className={`sidebar ${collapsed ? "collapsed" : ""}`}>
        <div className="sidebar-header">
          <h1>AI Made Human</h1>
          <p style={{ marginBottom: "8px" }}>Learn AI the easy way!</p>
          <a
            href="https://www.amazon.com/dp/B0G4W6F1PN"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              marginTop: "8px",
              fontWeight: 600,
              color: "#0071e3",
              textDecoration: "none",
            }}
          >
            📖 Buy the Book ↗
          </a>
        </div>
        <nav className="topic-nav">
          <Menu
            mode="vertical"
            selectedKeys={[activeTopic]}
            items={menuItems}
            onClick={handleMenuClick}
            style={{ border: "none" }}
          />
        </nav>
        <Button
          type="text"
          icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          onClick={() => setCollapsed(!collapsed)}
          className="collapse-button"
          title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        />
      </aside>
    </>
  );
};

export default Sidebar;
